var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"auth-view"}},[_c('v-content',{attrs:{"id":"auth-view-container"}},[_c('v-img',{attrs:{"src":_vm.backgroundImage,"height":"100%"}}),_c('transition',{attrs:{"name":"slide-fade"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }